export enum RadialMenuIcon {
	DespawnVehicle = 'remove_icon',
	RepairVehicle = 'repair_icon',
	FlipVehicle = 'rotate_icon',
	ToggleLights = 'light_car_icon',
	ToggleEngine = 'engine_icon',
	ToggleLock = 'lock_icon',
	ToggleTrunkLock = 'trunk_icon',
	ToggleSeatbelt = 'belt_icon',
	ShowVehiclePassport = 'pts_car_icon',
	VehicleOccupantsActions = 'occupants_actions_icon',
	Exit = 'exit_icon',
	Animate = 'animate_icon',
	Race = 'race_icon',
	Refuel = 'refuel_icon',
	Gun = 'gun_icon',
	Bonnet = 'bonnet_icon',
	FOV = 'fov_icon',
	GPSRemove = 'gps_remove_icon',
	InventoryCar = 'inventory_car_icon',
	EjectOccupant = 'eject_occupant_icon',
	Exchange = 'exchange_icon',
	ShowPhotoMode = 'show_photo_mode',
	Next = 'next_icon',
}

export interface IRadialMenuItem {
	action: string;
	icon: RadialMenuIcon;
	text: string;
	subText?: string;
	nestedItems?: IRadialMenuItem[] | null;
}

export interface IRadialMenuItemWithCoords extends IRadialMenuItem {
	path: string;
	iconX: number;
	iconY: number;
}
